import { action } from 'typesafe-actions'
import { TransactionTypes } from '../types/transaction'
import transactionService from 'src/services/transaction'

export const transactionAction = () => {
  return async (dispatch: any) => {
    dispatch(action(TransactionTypes.GET_TRANSACTION_REQUEST))
    const response: any = await transactionService.getTransactions()
    console.log(response.data.data.data)
    dispatch(
      action(
        TransactionTypes.GET_TRANSACTION_REQUEST_SUCCESS,
        response.data.data
      )
    )
  }
}
export const getPageTransactions = (pageNumber: any) => {
  return async (dispatch: any) => {
    dispatch(action(TransactionTypes.GET_TRANSACTION_REQUEST))
    try {
      const response: any = await transactionService.getPageTransactions(
        pageNumber
      )
      dispatch(
        action(
          TransactionTypes.GET_TRANSACTION_REQUEST_SUCCESS,
          response.data.data
        )
      )
    } catch (error) {
      console.log(error)
    }
  }
}
export const SearchTransactions = (description: any) => {
  return async (dispatch: any) => {
    dispatch(action(TransactionTypes.GET_TRANSACTION_REQUEST))
    try {
      const response: any = await transactionService.searchTransactions(
        description
      )
      dispatch(
        action(
          TransactionTypes.GET_TRANSACTION_REQUEST_SUCCESS,
          response.data.data
        )
      )
    } catch (error) {
      console.log(error)
    }
  }
}
export const filterTransactionsType = (type: any) => {
  return async (dispatch: any) => {
    dispatch(action(TransactionTypes.GET_TRANSACTION_REQUEST))
    try {
      const response: any = await transactionService.filterTransactionsType(
        type
      )
      dispatch(
        action(
          TransactionTypes.GET_TRANSACTION_REQUEST_SUCCESS,
          response.data.data
        )
      )
    } catch (error) {
      console.log(error)
    }
  }
}

export const filterTransactionsStatus = (status: any) => {
  return async (dispatch: any) => {
    dispatch(action(TransactionTypes.GET_TRANSACTION_REQUEST))
    try {
      const response: any = await transactionService.filterTransactionsStatus(
        status
      )
      dispatch(
        action(
          TransactionTypes.GET_TRANSACTION_REQUEST_SUCCESS,
          response.data.data
        )
      )
    } catch (error) {
      console.log(error)
    }
  }
}

export const filterTransactionsService = (service: any) => {
  return async (dispatch: any) => {
    dispatch(action(TransactionTypes.GET_TRANSACTION_REQUEST))
    try {
      const response: any = await transactionService.filterTransactionsService(
        service
      )
      dispatch(
        action(
          TransactionTypes.GET_TRANSACTION_REQUEST_SUCCESS,
          response.data.data
        )
      )
    } catch (error) {
      console.log(error)
    }
  }
}
